<template>
  <div>
    <div id="livechat" v-if="$store.getters.getPackage == 'premium'">
      <div v-if="view == 'users'">
        <div
          id="chattype"
          class="text-xs-center"
          style="position:fixed; top: 56px; right: 0; left: 0"
        >
          <v-layout>
            <v-flex>
              <v-btn
                depressed
                style="border-radius: 0;width: 100%"
                class="ma-0"
                :color="app == 'facebook' ? 'primary' : 'grey'"
                @click="app = 'facebook'"
                dark
              >
                <i class="fab fa-facebook"></i>
              </v-btn>
            </v-flex>
            <v-flex>
              <v-btn
                depressed
                style="border-radius: 0;width: 100%"
                class="ma-0"
                :color="app == 'line' ? 'primary' : 'grey'"
                @click="app = 'line'"
                dark
              >
                <i class="fab fa-line"></i>
              </v-btn>
            </v-flex>
            <v-flex>
              <v-dialog v-model="showSearch" width="500">
                <template v-slot:activator="{ on }">
                  <v-btn depressed style="border-radius: 0;width: 100%" class="ma-0" v-on="on">
                    <v-icon>search</v-icon>
                  </v-btn>
                </template>

                <v-card>
                  <div class="text-xs-right">
                    <v-btn flat fab small @click="showSearch = false">
                      <v-icon>close</v-icon>
                    </v-btn>
                  </div>

                  <v-card-text>
                    <div class="caption">{{ $t('Search') }}</div>
                    <div class="form-control">
                      <input type="text" v-model="filter.search" :placeholder="$t('Search')" />
                    </div>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </v-flex>
          </v-layout>
          <v-tabs
            id="usertype"
            v-model="type"
            color="grey lighten-3"
            :slider-color="$vuetify.theme.primary"
            @change="changeType"
          >
            <v-tab ripple :key="'admin'" :href="'#admin'">{{ $t('Inbox') }}</v-tab>
            <v-tab ripple :key="'bot'" :href="'#bot'">{{ $t('Bot') }}</v-tab>
          </v-tabs>
        </div>
        <div style="margin-top: 84px;">
          <users
            v-model="selectedUser"
            :app="app"
            :filter="filter"
            :type="'admin'"
            v-if="type == 'admin'"
            @onClickUser="onClickUser"
            :isMobile="true"
          ></users>
          <users
            v-model="selectedUser"
            :app="app"
            :filter="filter"
            :type="'bot'"
            v-if="type == 'bot'"
            @onClickUser="onClickUser"
            :isMobile="true"
          ></users>
        </div>
      </div>
      <div v-else-if="view == 'chatbox'">
        <chatbox
          v-model="selectedUser"
          @endSession="onEndSession"
          @onClose="onCloseChatbox"
          @onShowTool="onShowTool"
          :isMobile="true"
          :key="selectedUser.userid"
        ></chatbox>

        <v-navigation-drawer v-model="showTool" right fixed temporary>
          <v-layout>
            <v-flex>
              <v-btn fab small flat class="extra-small" @click="showTool = false">
                <v-icon>close</v-icon>
              </v-btn>
            </v-flex>
            <v-flex class="text-xs-right">
              <v-btn small outline @click="endSession" v-if="selectedUser.type == 'admin'"
                >End Session</v-btn
              >
              <v-btn small outline @click="openSession" v-else-if="selectedUser.type != 'admin'"
                >Open Session</v-btn
              >
            </v-flex>
          </v-layout>
          <template v-if="selectedUser">
            <div id="chattool" class="text-xs-center">
              <v-tabs
                v-model="chattooltype"
                color="grey lighten-3"
                :slider-color="$vuetify.theme.primary"
              >
                <v-tab ripple :key="'customer'" :href="'#customer'">{{ $t('Customer') }}</v-tab>
                <!-- <v-tab ripple :key="'conversation'" :href="'#conversation'">{{$t('Conversation')}}</v-tab> -->
              </v-tabs>
            </div>

            <div id style="overflow-y:auto" v-resize="onResizeToolList">
              <div v-if="chattooltype == 'customer'">
                <livechat-customers v-model="selectedUser"></livechat-customers>
              </div>
              <div v-else-if="chattooltype == 'conversation'">
                <div class="pa-1 form-control">
                  <input type="text" class="form-control" :placeholder="$t('Search')" />
                </div>
              </div>
            </div>
          </template>
        </v-navigation-drawer>
      </div>
    </div>
    <div v-else style="position: relative">
      <v-premium-plan-popup
        backgroundColor="white"
        v-if="$store.getters.getPackage != 'premium'"
        style="border-radius: 10px;min-height: 100vh; height: 100%; "
      ></v-premium-plan-popup>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import chatbox from './livechat-chatbox'
import api from '@/api'
import users from './livechat-users'
import LivechatCustomers from './livechat-customers'

export default {
  data: function() {
    return {
      showTool: false,
      view: 'users',
      app: 'facebook',
      type: 'admin',

      toolListHeight: 0,
      chattooltype: 'customer',
      showSearch: false,
      filter: {
        search: ''
      }
    }
  },
  components: {
    users,
    chatbox,
    LivechatCustomers
  },
  mounted: function() {
    var vm = this
    if (vm.$route.query.user) {
      vm.type = vm.$route.query.user == 'bot' ? 'bot' : 'admin'
    }

    // vm.onResizeToolList()
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      selectedUser: 'getCurrentUser'
    })
  },
  methods: {
    onShowTool: function() {
      this.showTool = !this.showTool
    },
    onCloseChatbox: function() {
      this.$set(this.$store.state.livechat, 'currentUser', null)
      this.view = 'users'
    },
    onClickUser: function() {
      this.view = 'chatbox'
    },
    onEndSession: function() {
      this.$set(this.$store.state.livechat, 'currentUser', null)
      this.$store.dispatch('updateLivechatUser', null)
      this.$store.dispatch('forceLoadLastestUsers')
      this.showTool = false
      this.view = 'users'
    },
    onOpenSession: function() {
      this.type = 'admin'
      var user = this.$store.state.livechat.currentUser
      user.type = this.type
      this.$store.dispatch('updateLivechatUser', user)
      this.$store.dispatch('forceLoadLastestUsers')
      this.updateRoute()
      this.showTool = false
      this.view = 'users'
    },
    changeType: function(name) {
      this.type = name
      this.updateRoute()
    },
    updateRoute: function() {
      this.$router.push({
        name: 'livechat',
        path: '/livechat',
        query: {
          user: this.type
        }
      })
      this.routeValue = JSON.stringify(this.$route.query)
    },
    endSession: function() {
      let vm = this
      if (vm.selectedUser == null || vm.selectedBot == null) {
        return false
      }
      let data = {
        pageid: vm.selectedBot.pageid,
        userid: vm.selectedUser.userid
      }

      vm.$store.dispatch('loading')
      api.endSessionChat(data, function(error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
          return
        }
        vm.onEndSession()

        vm.$store.dispatch('loading')
      })
    },
    openSession: function() {
      let vm = this
      if (vm.selectedUser == null || vm.selectedBot == null) {
        return false
      }
      let data = {
        pageid: vm.selectedBot.pageid,
        userid: vm.selectedUser.userid
      }
      vm.$store.dispatch('loading')
      api.openSessionChat(data, function(error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
          return
        }
        vm.onOpenSession()

        vm.$store.dispatch('loading')
      })
    },

    onResizeToolList: function() {
      var vm = this
      vm.$nextTick(function() {
        var toolListHeight = 0
        if (document.getElementById('chattool')) {
          toolListHeight = document.getElementById('chattool').clientHeight
        }
        vm.toolListHeight =
          window.innerHeight - document.getElementById('main_toolbar').clientHeight - toolListHeight
      })
    },
    sendMessage: function(payload) {
      let vm = this
      let data = {
        pageid: vm.selectedBot.pageid,
        userid: payload.data.user.userid,
        app: payload.data.app,
        messagetype: payload.data.type,
        messagevalue: payload.data.text,
        page_access_token: vm.selectedBot.page_access_token
      }

      let message = {
        answerby: 'admin',
        id: new Date().getTime(),
        messagedata: payload.data.text,
        messagetype: payload.data.type,
        pageid: vm.selectedBot.pageid,
        timestamp: new Date(),
        userid: payload.data.user.userid
      }

      api.sendMessage(data, function(error, response) {
        if (error) {
          console.error(error)
          // vm.$store.dispatch('loading')
          return
        }
        // vm.$store.dispatch('loading')
      })
    }
  },
  watch: {
    selectedBot: function(newVal, oldVal) {
      if (newVal != oldVal) {
        this.selectedUser = null
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/livechat/LivechatMobile.vue